module.exports = __webpack_public_path__ + "img/log-file.d91be37a.svg";